import { render } from "./Filtros_cat.vue?vue&type=template&id=2d1f6667&bindings={\"breadcrumbA\":\"data\",\"breadcrumbB\":\"data\",\"descripcion\":\"data\",\"triggers\":\"data\",\"empresas\":\"data\",\"obtenerEmpresas\":\"options\"}"
import script from "./Filtros_cat.vue?vue&type=script&lang=js"
export * from "./Filtros_cat.vue?vue&type=script&lang=js"
script.render = render

export default script